<template>
  <detail-layout>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
        >
          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('locations.cif')}}
                <el-form-item prop="cif">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.cif"
                  />
                </el-form-item>
              </label>
            </div>
          </div>
          <div class="lg:mb-2">
            <div class="mandatory">
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('locations.locationName')}}
                <el-form-item prop="location">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.location"
                  />
                </el-form-item>
              </label>
            </div>
          </div>
          <div class="lg:mb-2">
            <div class="mandatory">
              <base-ro-input :label="$t('configurations.created_at')" :data="form.created_at"/>
            </div>
          </div>
        </el-form>
    </div>
    </template>
    <template slot="layout-extend">
       <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
           <base-button-responsive mode="secondary" :text="$t('app.cancel')" icon="cross" @click="goBack" :loading="isGeneralLoading"/>
          <base-button-responsive mode="primary" :text="$t('app.save')" icon="save" @click="submitForm('ruleForm')" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
    </template>
    </template>
  </detail-layout>
</template>

<script>
import DetailLayout from '@/components/layout/DetailLayout.vue'
import { getSedesByEmpresa } from '@/services/app/getSedesByEmpresa'

import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'template-detail',
  components: {
    DetailLayout
  },
  data: function () {
    return {
      searchView: false,
      activeName: 'es',
      header: {
        title: 'SEDES DETALLE',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/locations'
      },
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      form: {
        id: 0,
        cif: '',
        location: '',
        created_at: ''
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      rules: {
        company: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        location: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    }
  },
  created: function () {

  },
  mounted: async function () {
    const locationId = this.$route.params.id
    await this.downloadData(locationId)
    const breadcrumbs = []
    breadcrumbs.push({ path: 'configurations/locations', name: this.$i18n.t('app.configurations') })
    breadcrumbs.push({ path: '', name: this.$i18n.t('app.locations') })
    breadcrumbs.push({ path: '', name: this.form.location })
    this.header.breadcrumb = breadcrumbs
  },
  methods: {
    watchFormHandler: function ({ certificate, send_alerts, automatic_download }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (automatic_download !== undefined) {
        this.form.automatic_download = !!automatic_download
      }
      if (send_alerts !== undefined) {
        this.form.send_alerts = !!send_alerts
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    submitForm: function (formName) {
      this.isProcessing = true
      setTimeout(() => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.doFeedback('Error al procesar los datos, revise la información', 'success')
            this.isProcessing = false
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
            this.isProcessing = false
            return false
          }
        })
      }, 1000)
    },
    goBack: function () {
      this.$router.push({ name: 'companies/locations' })
    },
    downloadData: async function (companyId) {
      let location = null
      try {
        this.$store.commit('setIsLoading', true)

        const params = {
          with: 'user,product'
        }
        location = await getSedesByEmpresa(companyId, params)
        if (location.blnError === true) {
          this.doFeedback(location.msgError + ' [Código de error: ' + location.codError + ']')
        } else {
          this.setLocation(location.data[0])
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return location
    },
    setLocation: function (location) {
      this.form.id = location.id
      this.form.cif = location.cif
      this.form.location = location.location
      this.form.created_at = location.created_at
    }
  }

}
</script>

<style scoped>
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr ;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic>img {
  max-width: 100%;
}

</style>

<style lang="sass" scoped>
</style>
